/**
 * Created by sagardesai on 22/06/18.
 */
import {RSAA} from 'redux-api-middleware';
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../util/constants";
import * as types from './types/index';
import {handleUnauthorizedAccess} from "../util/utility";

export function getFollowingList(token, api_token, query, filter_by) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/following?api_token=${api_token}&filter_by=${filter_by}&query=${query}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FOLLOWING_LIST_REQUEST, types.FOLLOWING_LIST_RECEIVE, {
                type: types.FOLLOWING_LIST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function followBroadcaster(token, api_token, broadcaster_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/follow/broadcaster/${broadcaster_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FOLLOW_UNFOLLOW_BROADCASTER_REQUEST, types.FOLLOW_UNFOLLOW_BROADCASTER_RECEIVE, {
                type: types.FOLLOW_UNFOLLOW_BROADCASTER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}


export function unFollowBroadcaster(token, api_token, broadcaster_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/unfollow/broadcaster/${broadcaster_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FOLLOW_UNFOLLOW_BROADCASTER_REQUEST, types.FOLLOW_UNFOLLOW_BROADCASTER_RECEIVE, {
                type: types.FOLLOW_UNFOLLOW_BROADCASTER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function favoriteUser(token, api_token, broadcaster_id){
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/favorite/user/${broadcaster_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FAVORITE_BROADCASTER_REQUEST, types.FAVORITE_BROADCASTER_RECEIVE, {
                type: types.FAVORITE_BROADCASTER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetFollowingList = () => ({
    type: types.RESET_FOLLOWING_LIST,
    payload: null
});

export const resetFollowUnFollowData = () => ({
    type: types.RESET_FOLLOW_UNFOLLOW_BROADCASTER,
    payload: null
});

export const setSearchFollowingState = (state) => ({
    type: types.SET_SEARCH_FOLLOWING_STATE,
    payload: state
});


